import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/timeoutparkinganalysisregulation/getpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/timeoutparkinganalysisregulation/getdetail/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/timeoutparkinganalysisregulation/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const datevehicleInfoGroupdurationlimit = (params, urlParams) => {
  return axios.request({
    url: '/da/timeoutparkinganalysisregulation/timeoutparkinganalysisregulation/updatevehicleInfoGroupdurationlimit/' + params.vehicleInfoGroupids + '/' + params.durationlimit + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const datedurationlimit = (params, urlParams) => {
  return axios.request({
    url: '/da/timeoutparkinganalysisregulation/timeoutparkinganalysisregulation/' + params.terminalNum + '/' + params.durationlimit + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

